import { Tag } from 'antd';
import { priceTransformer } from 'utils';

/** Fixed widths so every expanded payout uses the same column grid. */
const lineItemColumns = [
  {
    title: 'Order number',
    dataIndex: 'order_number',
    key: 'order_number',
    width: 160,
  },
  {
    title: 'Restaurant',
    dataIndex: 'restaurant_name',
    key: 'restaurant_name',
    width: 280,
    ellipsis: true,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    width: 120,
    align: 'right',
    render: (value) => priceTransformer(value / 100),
  },
  {
    title: 'Payment type',
    dataIndex: 'label',
    key: 'label',
    width: 140,
    render: (value) => (value ? <Tag>{value}</Tag> : null),
  },
];

export default lineItemColumns;
